import { AIRPORT, THING_TO_DO, TRANSPORT } from './location-constants';

import type { PoiDataArray } from '@shared/types/frontend/nearby-transport-response';
import type { I18nService } from '@shared/types/i18n';

export const getPoiCards = ({
  airport,
  i18n,
  nearbyPoi,
  transportWithoutAirport,
}: {
  i18n: I18nService;
  nearbyPoi: PoiDataArray;
  transportWithoutAirport: PoiDataArray;
  airport: PoiDataArray;
}) => {
  const poiCards = [];
  if (nearbyPoi && nearbyPoi.length > 0) {
    poiCards.push({
      tab: THING_TO_DO,
      title: i18n.translatePlural(
        'Distance_label_acctractions',
        nearbyPoi.length,
        'number',
      ),
      data: nearbyPoi,
    });
  }
  if (transportWithoutAirport && transportWithoutAirport.length > 0) {
    poiCards.push({
      tab: TRANSPORT,
      title: i18n.translate('HotelDetail_map__poi__Transportation'),
      data: transportWithoutAirport,
    });
  }
  if (airport && airport.length > 0) {
    poiCards.push({
      tab: AIRPORT,
      title: i18n.translate('HotelDetail_map__poi__Airport'),
      data: airport,
    });
  }
  return poiCards;
};

export const isSinglePoi = ({
  airport,
  nearbyPoi,
  transportWithoutAirport,
}: {
  nearbyPoi: PoiDataArray;
  transportWithoutAirport: PoiDataArray;
  airport: PoiDataArray;
}) => {
  const hasAirport = airport.length > 0;
  const hasTransport = transportWithoutAirport.length > 0;
  const hasPoi = nearbyPoi.length > 0;

  return [hasPoi, hasAirport, hasTransport].filter((item) => item).length === 1;
};
